export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const SHOW_RESULTS = 'SHOW_RESULTS';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';

export function updateSearchTerm(term) {
  return {
    type: UPDATE_SEARCH_TERM,
    term
  };
}

export function toggleResults(show) {
  return {
    type: SHOW_RESULTS,
    showResults: show
  };
}

export function clearResults() {
  return {
    type: CLEAR_RESULTS
  };
}
